import { Controller } from 'react-hook-form';
import { Form, Switch } from 'antd';
import type { FieldValues } from 'react-hook-form';
import type { SwitchProps } from 'antd';
import type { RHFBaseProps, CommonChrome } from './types';
import { DEFAULT_FORM_LAYOUT } from './constants';

export type ControlledSwitchProps<TFieldValues extends FieldValues = FieldValues> =
  RHFBaseProps<TFieldValues> & CommonChrome & Omit<SwitchProps, 'checked' | 'onChange'>;

export function ControlledSwitch<TFieldValues extends FieldValues = FieldValues>({
  name,
  label,
  required,
  disabled,
  control,
  help,
  layout,
  fieldClassName,
  ...rest
}: ControlledSwitchProps<TFieldValues>) {
  const resolvedLayout = layout ?? DEFAULT_FORM_LAYOUT;
  const isHorizontal = resolvedLayout === 'horizontal';

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState }) => (
        <Form.Item
          label={label}
          required={required}
          validateStatus={fieldState.error ? 'error' : undefined}
          help={fieldState.error?.message ?? help}
          layout={resolvedLayout}
          labelCol={
            isHorizontal
              ? { flex: '0 0 auto', style: { paddingInlineEnd: 12 } }
              : undefined
          }
          wrapperCol={isHorizontal ? { flex: '0 0 auto' } : undefined}
          colon={isHorizontal ? false : undefined}
          style={
            isHorizontal ? { marginBottom: 0, justifyContent: 'flex-start' } : undefined
          }
          className={fieldClassName}
        >
          <Switch {...rest} checked={!!value} onChange={onChange} disabled={disabled} />
        </Form.Item>
      )}
    />
  );
}
